import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import SinusLiftingLIcon from "./images/SinusLiftingL.png";
import SinusLiftingRIcon from "./images/SinusLiftingR.png";
import SinusLiftingBothIcon from "./images/SinusLiftingBoth.png";
import SinusClearIcon from "./images/NormalSinus.png";
import SelectionTypeList from "../../SelectionTypeList";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const BRSinusLifting = ({
  stepId,
  setNextKeyPrefix,
  currentChoice,
  toggleNextBtnState
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    let sinuses = dentalData?.sinuses || [];
    return [{
      key: "sinusLiftingRight",
      img: SinusLiftingRIcon,
      name: _t("Синус-лифтинг справа"),
      disabled: !sinuses.includes("lowSinusesRight")
    }, {
      key: "sinusLiftingLeft",
      img: SinusLiftingLIcon,
      name: _t("Синус-лифтинг слева"),
      disabled: !sinuses.includes("lowSinusesLeft")
    }, {
      key: "sinusLiftingBoth",
      img: SinusLiftingBothIcon,
      name: _t("Синус-лифтинг с обоих сторон"),
      disabled: !sinuses.includes("lowSinusesLeft") || !sinuses.includes("lowSinusesRight")
    }, {
      key: "removeSelection",
      img: SinusClearIcon,
      name: _t("Убрать выделенное")
    }];
  }, [_t, dentalData]);
  const runOnce = useRef(false);
  useEffect(() => {
    if (!runOnce.current) {
      if (!currentChoice || !currentChoice.hasOwnProperty("formula") || !currentChoice.formula.hasOwnProperty("sinuses") || !currentChoice.formula.sinuses.length) {
        toggleNextBtnState(true);
        runOnce.current = true;
      }
    }
  }, [currentChoice, setNextKeyPrefix, toggleNextBtnState]);
  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  const [selected, setSelected] = useState("");

  function setData(key) {
    if (!isFormulaLoaded) {
      return;
    }

    setSelected(key === "removeSelection" ? "" : key);
    let updatedData = {};
    let sinusData = dentalData?.sinuses ? dentalData.sinuses.filter(el => !["sinusLiftingLeft", "sinusLiftingRight"].includes(el)) : [];

    switch (key) {
      case "sinusLiftingLeft":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "sinusLiftingLeft"]
        };
        break;

      case "sinusLiftingRight":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "sinusLiftingRight"]
        };
        break;

      case "sinusLiftingBoth":
        updatedData = { ...dentalData,
          sinuses: [...sinusData, "sinusLiftingLeft", "sinusLiftingRight"]
        };
        break;

      case "removeSelection":
        updatedData = {
          sinuses: [...sinusData]
        };
        break;

      default:
        break;
    }

    setStepFormula(stepId, updatedData);
    toggleNextBtnState(false);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "brSinusLifting"
  }, /*#__PURE__*/React.createElement("div", {
    className: "brSinusLifting-types"
  }, /*#__PURE__*/React.createElement("p", null, _t("Выберите ниже")), /*#__PURE__*/React.createElement(SelectionTypeList, {
    types: availableTypes,
    selected: selected,
    setData: setData,
    columns: 2,
    disable: !isFormulaLoaded
  })), /*#__PURE__*/React.createElement("div", {
    className: "brSinusLifting-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    availableSwitchers: ["softTissue", "skull", "prosthesisAll"],
    hideNotUsedSides: false,
    onLoaded: formulaLoadedCallback
  })));
};

export default BRSinusLifting;